import styled from '@emotion/styled/macro';

export const Box = styled.div`
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
    background: #fff;
    min-width: 311px;
    max-width: 343px;
    @media (max-width: 320px) {
        min-width: auto;
        max-width: 98%;
    }
    padding: ${props => props.theme.spacing.large};
    text-align: center;
    margin: 20px auto;
`;

export const BoxText = styled.p`
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 400;
    line-height: 22px;
    margin-bottom: ${props => props.theme.spacing.large};
    margin-bottom: 0;
`;

export const Highlighted = styled.span`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: bold;
`;
